import { useParams } from "react-router-dom";
import invariant from "ts-invariant";

import { useGetLesson } from "api/services/content/hooks/useGetLesson";
import { useProfileContext } from "contexts/ProfileContext";
import { PageContainer } from "routes/library/components";

import { LessonForm } from "./LessonForm";

export const LessonFormParent: React.FC = () => {
  const { id } = useParams();
  const { profile } = useProfileContext();

  invariant(profile, "Profile should be defined");

  const lessonID = id ? parseInt(id, 10) : -1;
  const { data: lesson, isError, isLoading } = useGetLesson(lessonID);

  return (
    <PageContainer disableBlocking isError={isError} isLoading={isLoading}>
      {lesson && <LessonForm lesson={lesson} />}
    </PageContainer>
  );
};
